import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/docs/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Swagger = makeShortcode("Swagger");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "datedservicejourney"
    }}>{`DatedServiceJourney`}</h1>
    <p>{`Application responsible for producing and providing persistent DatedServiceJourneyIds from NeTEx-data.`}</p>
    <h1 {...{
      "id": "examples"
    }}>{`Examples`}</h1>
    <p>{`Find entity based on ServiceJourneyId + date:
`}<a parentName="p" {...{
        "href": "https://api.entur.io/timetable/v1/dated-service-journeys/NSB:ServiceJourney:1-2102-3036/latest/2019-05-15"
      }}>{`https://api.entur.io/timetable/v1/dated-service-journeys/NSB:ServiceJourney:1-2102-3036/latest/2019-05-15`}</a></p>
    <p>{`Find same entity as above, but based on DatedServiceJourney:
`}<a parentName="p" {...{
        "href": "https://api.entur.io/timetable/v1/dated-service-journeys/dated/ENT:DatedServiceJourney:3333333"
      }}>{`https://api.entur.io/timetable/v1/dated-service-journeys/dated/ENT:DatedServiceJourney:3333333`}</a></p>
    <p>{`Find all DatedServiceJourneys referring to the same OriginalDatedServiceJourney as above:
`}<a parentName="p" {...{
        "href": "https://api.entur.io/timetable/v1/dated-service-journeys/original/ENT:DatedServiceJourney:381881"
      }}>{`https://api.entur.io/timetable/v1/dated-service-journeys/original/ENT:DatedServiceJourney:381881`}</a></p>
    <Swagger url="https://api.entur.io/timetable/v1/dated-service-journeys/api-doc/swagger.json" mdxType="Swagger" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      